import { useContext } from "react";
import { EppoFeatureFlagContext } from "src/contexts/eppoFeatureFlag.context";
import { EppoFeatureFlags } from "src/types/featureFlags";

export const useFeatureFlags = (): EppoFeatureFlags => {
  const featureFlags = useContext(EppoFeatureFlagContext);

  return featureFlags;
};
